/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { ISettingsCompProps, UsersList, IUsersListProps } from './components';

const SwalWithBootstrapButtons = withReactContent(
  Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary me-3',
      cancelButton: 'btn btn-secondary',
    },
    buttonsStyling: false,
  })
);

export type IUsersListTableProps = ISettingsCompProps &
  IUsersListProps & {
    ultUsers: any[];
  };

export const UsersListTable = ({
  ultUsers,
  onRevokeClick,
  ...rest
}: IUsersListTableProps) => {
  const [users, setUsers] = useState(
    ultUsers.map((u) => ({ ...u, isSelected: false, show: true }))
  );
  const selectedUsersIds = users.filter((u) => u.isSelected).map((u) => u.id);
  const totalUsers = users.length;
  const allSelected = selectedUsersIds.length === totalUsers;

  const selectUser = (id) => {
    console.log('select user =>', id);
    const newUsers = users.map((u) =>
      u.id === id ? { ...u, isSelected: !u.isSelected } : u
    );
    setUsers(newUsers);
  };

  const selectAllUsers = () => {
    const newUsers =
      selectedUsersIds.length === totalUsers
        ? users.map((u) => ({ ...u, isSelected: false }))
        : users.map((u) => ({ ...u, isSelected: true }));
    setUsers(newUsers);
  };
  const deleteUsers = async (ids) => {
    const usersToBeDeleted = ids ? ids : selectedUsersIds;
    console.log('usersToBeDeleted =>', usersToBeDeleted);
    const usersNr = usersToBeDeleted.length;
    const textMessage =
      usersNr === 1
        ? 'Are you sure do you want to revoke this credential?'
        : `Are you sure do you want to revoke these ${usersNr} credentials?`;

    //@ts-ignore
    const result = await SwalWithBootstrapButtons.fire({
      icon: 'error',
      title: 'Confirm Revocation',
      text: textMessage,
      showCancelButton: true,
      allowOutsideClick: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      onRevokeClick && onRevokeClick(usersToBeDeleted);
    }
  };

  return (
    <>
      <UsersList
        {...rest}
        users={users.filter((u) => u.show)}
        allSelected={allSelected}
        ultSelectUser={selectUser}
        ultDeleteUser={deleteUsers}
        ultSelectAllUsers={selectAllUsers}
      />
    </>
  );
};

UsersListTable.defaultProps = {
  ultUsers: [],
};
